import { render, staticRenderFns } from "./rechangelist.vue?vue&type=template&id=0c16ac56"
import script from "./rechangelist.vue?vue&type=script&lang=js"
export * from "./rechangelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports